import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
// import { useDispatch } from 'react-redux';
import Grid from '@material-ui/core/Grid';
// import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
// import Fab from '@material-ui/core/Fab';
// import AddIcon from '@material-ui/icons/Add';
import Alert from '@material-ui/lab/Alert';
// import AlertTitle from '@material-ui/lab/AlertTitle';
// import IconButton from '@material-ui/core/IconButton';
// import IconButton from '@material-ui/core/IconButton';
import axios from 'axios';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles, Card, CardContent, InputLabel, Select, FormControl, Snackbar, Typography } from '@material-ui/core';
import SearchBox from '../../../../components/table/SearchBox';
import ActionTable from '../../common/Table';
import FormDialog from '../../../../components/table/FormDialog';
import { CommonConfig } from '../../../../config/common-config';
import LoaderPopUp from '../../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../../components/loaderpopup/success';
import ErrorPopUp from '../../../../components/loaderpopup/error';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    container: {
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
    btnBluepop: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
        margin: '0px 0px 10px 14px !important',
    },
    popFoot: {
        justifyContent: 'flex-start',
    },
    textMessage: {
        fontFamily: 'Rubik',
        marginBottom: '0px !important',
    }
}));
function AdminCorpInvoice(props) {
    const history = useHistory();
    const [rows, setTotalReactPackages] = useState([]);
    const [AllImcs, setAllImcs] = useState([]);
    const [selectedImc, setselectedImc] = useState([]);
    const [isError, setisError] = useState([]);
    const [deletedata, setDeleteData] = useState(rows);
    const [openBox, setOpenBox] = useState(false);
    const [deleteMsg, setDeleteMsg] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [showLoader, setShowLoader] = useState(false);

    const vertical = 'top';
    const horizontal = 'center';
    const classes = useStyles();
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const [confirmView, setConfirmView] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };
    const handleClose = () => {
        // setOpenBox(false);
        setSuccessPop(false);
        setErrorPop(false);
    };

    const headcells = [
        { id: 'corpClientName', label: 'Client' },
        { id: 'person1Emailid', label: 'Email' },
        { id: 'person1Mobnumber', label: 'Phone' },
        { id: 'gstin', label: 'GSTIN' },
        {
            id: 'addressId',
            label: 'Address',
            isConcat: 'true',
            concatElem: ['addressLine1', 'addressLine2', 'city', 'stateId.stateName', 'country'],
        },
    ];

    const { breadCrumbLabel, breadCrumbPath } = props;

    useEffect(
        (data) => {
            axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`, axiosConfig)
                .then((response) => setAllImcs(response.data.content))
                .catch((error) => {
                    //console.log(error);
                });

            axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/ultimate_corp_client/${selectedImc}?page=0&size=1000&sort=corpclientId,desc`, axiosConfig)
                .then((response) => {
                    setTotalReactPackages(response.data.content);
                    //console.log(response.data.content);
                });
            // .then(response => ////console.log(response.data.content));
        },
        [deletedata, userToken]
    );

    const handleSearchQuery = (data) => {
        setSearchQuery(data);
    };
    const handleSave = () => { };

    const handleDelete = (data) => {
        setShowLoader(true);
        if (data.corpclientId) {
            axios
                .delete(`${CommonConfig.dev.baseUrl}/api/auth/ultimate_corp_client/${selectedImc}/${data.corpclientId}`, axiosConfig)
                .then((response) => {
                    const { status } = response;
                    if (status === 200) {
                        const list = rows.filter((item) => item.corpclientId !== data.corpclientId);
                        setDeleteData({ rows: list });
                        setShowLoader(false);
                        setSuccessPop(true);
                        setTimeout(() => {
                            setSuccessPop(false);
                        }, 3000);
                    }
                })
                .catch((e) => {
                    setShowLoader(false);
                    if (e && e.response && e.response.data && e.response.data.message) {
                        setConfirmView(true);
                        setErrorMessage(e.response.data.message)
                    } else {
                        setErrorPop(true);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                    }
                });
        }
    };

    const navigate = () => {
        // const { history } = props;

        history.push('/menu/ClientCorporateCreate');
    };

    const allImcsOptions = (vv) => {
        const OptionList = vv.map((data) => <option value={data.dbName}>{data.dbName}</option>);
        return OptionList;
    };

    const setAlert = () => {
        return <Alert severity="error">Alert</Alert>;
    };

    const setImc = (e) => {
        setselectedImc(e.target.value);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/ultimate_corp_client/${e.target.value}?page=0&size=400&sort=corpclientId,desc`, axiosConfig)
            .then((response) => {
                setTotalReactPackages(response.data.content);
                //console.log(response.data.content);
            })
            .catch((error) => {
                //console.log(error.response.data);
                if (error.response.data) {
                    setisError(error.response.data);

                    setTotalReactPackages([]);
                }
            });
    };

    const handleGenerate = (row) => {
        history.push({
            pathname: '/taxInvoice',
            row,
        });
    };

    const filteredRow = searchQuery
        ? rows.filter((row) => {
            const query = searchQuery.toLowerCase().trim();
            //console.log(Object.keys(row) ,"Keys of ROW**** object.keys()");
            //console.log(query,"query");
            return headcells
                .map((col) => col.id)
                .some((key) => {
                    //console.log(row[key],"Value of ROW****row[key]");
                    return row[key].toString().toLowerCase().includes(query);
                });
        })
        : rows;
    const handleRoleChange = (event) => {
        switch (event.target.value) {
            case 'Individual':
                history.push('/menu/indInvoice');
                return true;
            case 'Corporate':
                history.push('/menu/corpInvoice');
                return true;
            default:
                return true;
        }
    };

    return (
        <>
            {/* <Snackbar
                className="deleteError"
                open={openBox}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={handleClose}
            >
                <Alert onClose={handleClose} severity="success">
                    {deleteMsg}
                </Alert>
            </Snackbar> */}
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Record deleted successfully" />) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />) : null}
            {showLoader ? (<LoaderPopUp showLoader={showLoader} handleClose={handleClose} />) : null}

            <Dialog
                open={confirmView}
                onClose={() => setConfirmView(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
            >
                {/* <DialogTitle className={classes.popTitle} id="alert-dialog-title">
                    Confirmation
                </DialogTitle> */}
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className={classes.textMessage}>
                        {errorMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.popFoot}>
                    <Button onClick={() => setConfirmView(false)} variant="outlined" color="primary" size="small" className={classes.btnBluepop}>
                        Ok
                    </Button>
                    {/* <Button onClick={proceedToTax} variant="outlined" color="primary" size="small" className={classes.btnBluepop}>
                        Ok
                    </Button> */}
                </DialogActions>
            </Dialog>

            <Card className="custom-table">
                <Grid container spacing={3} className="main-container w100i field-container1">
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <ul className="genderli radioalignment">
                                <li>
                                    <div className="custom-control">
                                        <input
                                            id="Individual"
                                            type="radio"
                                            value="Individual"
                                            // name="gender"
                                            onChange={handleRoleChange}
                                            defaultValue="Individual"
                                        />
                                        <label className="custom-control-label" htmlFor="Individual">
                                            Individual
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div className="custom-control">
                                        <input
                                            id="Corporate"
                                            type="radio"
                                            value="Corporate"
                                            checked="true"
                                            // name="gender"
                                            onChange={handleRoleChange}
                                        />
                                        <label className="custom-control-label" htmlFor="Corporate">
                                            Corporate
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel className="lbl " htmlFor="selectimc" shrink>
                                Select IMC
                            </InputLabel>
                            <Select native className="bottom" name="intclientName" onChange={setImc} value={selectedImc}>
                                <option value="" selected disabled hidden>
                                    Select IMC
                                </option>
                                {allImcsOptions(AllImcs)}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <CardContent className="card-title-display">
                    <Grid item xs={12} sm={6}>
                        <Typography className="card-title">Corporate Client List</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} className="card-search">
                        <div className="search-field">
                            <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} placeholder="Search..." />
                            <FormDialog row={[]} saveRow={handleSave} pageName="individual" show="AddIcon" />
                        </div>
                    </Grid>
                </CardContent>
                <CardContent className="card-table-display">
                    {/* <div style={{ textAlign: 'center' }}>
                    <h1 style={{ color: '#31333F', fontFamily: 'Rubik', fontWeight: '400' }}>Corporate Client List</h1>
                </div> */}

                    {/* <div className="itec-textboxes">
                    Select IMC to view Corporate client{' '}
                    <select className="intclientName intSelect" name="intclientName" onChange={setImc} value={selectedImc}>
                        <option value="" selected disabled hidden>
                            Select IMC
                        </option>
                        {allImcsOptions(AllImcs)}
                    </select>
                </div> */}

                    {filteredRow.length > 0 ? (
                        <>
                            {/* <div>
                                    <Grid container style={{ marginBottom: 10 }}>
                                        <Grid item xs={12} sm={6} direction="row" justify="flex-end" alignItems="flex-end">
                                            <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} placeholder="Search..." />
                                        </Grid>
                                    </Grid>
                                    <FormDialog row={[]} saveRow={handleSave} pageName="individual" show="AddIcon" />
                                </div> */}
                            <ActionTable
                                headcells={headcells}
                                rows={filteredRow}
                                generate={handleGenerate}
                                action
                                post="admin"
                                mode="generate"
                            />
                        </>
                    ) : (
                            <div>
                                {/* <Grid container style={{ marginBottom: 10 }}>
                                    <Grid item xs={12} sm={6} direction="row" justify="flex-end" alignItems="flex-end">
                                        {searchQuery && (
                                            <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} placeholder="Search..." />
                                        )}
                                    </Grid>
                                </Grid> */}
                                {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 100 }}>
                            <h1 style={{ alignSelf: 'center', color: 'grey', fontFamily: 'Rubik' }}> No records to display</h1>
                        </div> */}

                                <div className={classes.noRecord}>
                                    <h1>No records to display</h1>
                                </div>
                            </div>
                        )}
                </CardContent>
            </Card>
        </>
    );
}

export default AdminCorpInvoice;
